<template>
    <div>
        <Card>
            <Card>
                <p slot="title">{{t.dict.searchName}}</p>
                <Form :model="formItem" :label-width="100" label-position="right">
                    <Row :gutter="16">
                        <Col span="8">
                            <Form-item :label="t.dict.label">
                                <Input v-model="formItem.label"
                                       :placeholder="msgUtil.placeholderRequired(t.dict.label)"></Input>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.dict.createStartTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createStartTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderSelected(t.dict.createStartTime)"
                                            :options="createStartTimeOption"
                                            @on-change="onStartTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                        <Col span="8">
                            <Form-item :label="t.dict.createEndTime">
                                <DatePicker type="datetime" format="yyyy/MM/dd HH:mm:ss"
                                            v-model="formItem.createEndTime" style="width: 100% !important"
                                            :placeholder="msgUtil.placeholderSelected(t.dict.createEndTime)"
                                            :options="createEndTimeOption"
                                            @on-change="onEndTimeChange"></DatePicker>
                            </Form-item>
                        </Col>
                    </Row>
                    <Row :gutter="16">
                        <Col span="8">
                            <Form-item :label="t.dict.status">
                                <Select v-model="formItem.status" clearable style="width: 100% !important"
                                        :placeholder="msgUtil.placeholderSelected(t.dict.status)">>
                                    <Option value="1">{{t.dict.open}}</Option>
                                    <Option value="0">{{t.dict.close}}</Option>
                                </Select>
                            </Form-item>
                        </Col>
                        <Col span="16">
                            <Button type="primary" icon="ios-search" style="float: right;" @click="search(true)">
                                {{msgUtil.message.action.search}}
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Card>
            <Row class="margin-top-10">
                <Col span="12">
                    <sort-button-group :buttons="sortButton" @on-order="orderClick"/>
                </Col>
                <Col style="text-align:right;" span="12">
                    <!-- name 是路由名，参考的@/router/organization/dictDto.js的名 -->
                    <Button icon="md-add" to="./add">{{msgUtil.message.action.add}}</Button>
                    <Button icon="ios-trash" @click="delAll">{{msgUtil.message.action.deleteAll}}</Button>
                </Col>
            </Row>
            <Row class="margin-top-10">
                <Table ref="selection" :context="self" :columns="columns" :data="data" :loading="loading"
                       @on-selection-change="rowSelect"></Table>
            </Row>
            <Row class="margin-top-10" type="flex" justify="end">
                <Page ref="page" :total="total" show-total show-sizer @on-change="pageChange"
                      @on-page-size-change="pageSizeChange">
                    {{msgUtil.message.page.total}} {{ total }} {{msgUtil.message.page.paper}}
                </Page>
            </Row>
        </Card>
    </div>
</template>
<script>
import { Message } from 'iview';
import { del, delAll, getDictList } from '@/api/dict';
import sortButtonGroup from '@/components/sort-button-group.vue';

export default {
    name: 'sys_manage_dict_list',
    components: {
        sortButtonGroup,
    },
    data() {
        const t = this.$_t();
        const msgUtil = this.$msgUtil;
        const renderSortOrder = (h, params) => {
            const row = params.row;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                    },
                },
                row.sortOrder
            );
        };
        const renderLabel = (h, params) => {
            const row = params.row;
            return h('div', [
                h(
                    'router-link',
                    {
                        props: {
                            to: './detail/' + row.id,
                        },
                    },
                    row.label
                ),
            ]);
        };
        const renderBody = (h, params) => {
            const row = params.row;
            let hasBody = row.body !== '' ? t.table.hasBody : t.table.hasNotBody;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                    },
                },
                hasBody
            );
        };
        const renderStatus = (h, params) => {
            const row = params.row;
            const color = row.status === '0' ? 'error' : row.status === '1' ? 'success' : 'error';
            const text = row.status === '0' ? t.dict.close : row.status === '1' ? t.dict.open : t.dict.close;
            return h(
                'Tag',
                {
                    props: {
                        type: 'border',
                        color: color,
                    },
                },
                text
            );
        };
        const renderAction = (h, params) => {
            const row = params.row;
            return h('button-group', [
                h(
                    'i-button',
                    {
                        props: {
                            type: 'primary',
                            size: 'small',
                            to: './edit/' + row.id,
                        },
                    },
                    msgUtil.message.action.edit
                ),
                h(
                    'i-button',
                    {
                        props: {
                            type: 'error',
                            size: 'small',
                            style: 'margin-left:5px',
                        },
                        on: {
                            click: this.del.bind(this, row.id),
                        },
                    },
                    msgUtil.message.action.delete
                ),
            ]);
        };
        return {
            self: this,
            t: t,
            msgUtil: msgUtil,
            formItem: {
                sortOrder: '',
                label: '',
                data1: '',
                data2: '',
                data3: '',
                data4: '',
                data5: '',
                data6: '',
                data7: '',
                data8: '',
                data9: '',
                data10: '',
                status: '',
                createBy: '',
                createTime: '',
                createStartTime: '',
                createEndTime: '',
                body: '',
                oa: '',
                od: '',
                current: 1,
                size: 10,
            },
            createStartTimeOption: {},
            createEndTimeOption: {},
            selectIds: [],
            data: [],
            total: 0,
            columns: [
                { title: '', type: 'selection', align: 'center', width: 44 },
                { title: t.table.id, key: 'id', align: 'center', width: 164 },
                {
                    title: t.table.label,
                    key: 'label',
                    align: 'center',
                    width: 120,
                    tooltip: true,
                    render: renderLabel,
                },
                { title: t.table.sortOrder, key: 'sortOrder', align: 'center', width: 80, render: renderSortOrder },
                { title: t.table.data1, key: 'data1', align: 'center', width: 160, tooltip: true },
                { title: t.table.data2, key: 'data2', align: 'center', width: 160, tooltip: true },
                { title: t.table.data3, key: 'data3', align: 'center', width: 160, tooltip: true },
                { title: t.table.data4, key: 'data4', align: 'center', width: 160, tooltip: true },
                { title: t.table.data5, key: 'data5', align: 'center', width: 160, tooltip: true },
                { title: t.table.data6, key: 'data6', align: 'center', width: 160, tooltip: true },
                { title: t.table.data7, key: 'data7', align: 'center', width: 160, tooltip: true },
                { title: t.table.data8, key: 'data8', align: 'center', width: 160, tooltip: true },
                { title: t.table.data9, key: 'data9', align: 'center', width: 160, tooltip: true },
                { title: t.table.data10, key: 'data10', align: 'center', width: 160, tooltip: true },
                { title: t.table.body, key: 'body', align: 'center', width: 90, render: renderBody },
                { title: t.table.createBy, key: 'createBy', width: 160, tooltip: true },
                { title: t.table.createTime, key: 'createTime', width: 150 },
                { title: t.table.status, key: 'status', align: 'center', width: 120, render: renderStatus },
                { title: ' ', align: 'center' },
                {
                    title: msgUtil.message.action.name,
                    key: 'action2',
                    align: 'center',
                    width: 130,
                    fixed: 'right',
                    render: renderAction,
                },
            ],
            // 排序btn
            sortButton: [
                { key: 'label', value: t.dict.label, order: 0 },
                { key: 'sortOrder', value: t.dict.sortOrder, order: 0 },
                { key: 'status', value: t.dict.status, order: 0 },
                { key: 'createTime', value: t.dict.createTime, order: 0 },
            ],
            loading: false,
        };
    },
    methods: {
        //排序
        async orderClick(btn) {
            this.formItem.oa = '';
            this.formItem.od = '';
            if (btn.order === 1) {
                this.formItem.oa = btn.key;
            } else if (btn.order === 2) {
                this.formItem.od = btn.key;
            }
            await this.search(true);
        },
        //数据检索
        async search(flg) {
            if (flg) {
                this.formItem.current = 1;
                this.$refs.page.currentPage = 1;
            }
            this.loading = true;
            await this.wrapperCreateTime();
            //console.log(this.formItem);
            let dictDto = {};
            dictDto.label = this.formItem.label;
            dictDto.status = this.formItem.status;
            dictDto.createTime = this.formItem.createTime;
            dictDto.oa = this.formItem.oa;
            dictDto.od = this.formItem.od;
            dictDto.current = this.formItem.current;
            dictDto.size = this.formItem.size;
            const result = await getDictList(dictDto);
            //console.log(result);
            if (result) {
                this.data = result.page.records;
                this.total = result.page.total;
            }
            this.loading = false;
        },
        //创建时间作成
        async wrapperCreateTime() {
            this.formItem.createTime = '';
            if (this.formItem.createStartTime !== '' && this.formItem.createStartTime !== undefined) {
                this.formItem.createTime = this.formItem.createStartTime + ',';
            }
            if (this.formItem.createEndTime !== '' && this.formItem.createEndTime !== undefined) {
                if (this.formItem.createStartTime === '' || this.formItem.createStartTime === undefined) {
                    this.formItem.createTime = ',';
                }
                this.formItem.createTime += this.formItem.createEndTime;
            }
        },
        // 页号改变
        async pageChange() {
            this.formItem.current = this.$refs.page.currentPage;
            await this.search(false);
        },
        // 每页显示数据
        async pageSizeChange() {
            this.formItem.size = this.$refs.page.currentPageSize;
            await this.search(false);
        },
        // 删除
        async del(id) {
            await del(id);
            await this.search(true);
        },
        // 批量删除
        async delAll() {
            if (this.selectIds.length === 0) {
                Message.error({
                    content: this.msgUtil.message.warn.notSelectedRow,
                    duration: 60,
                    closable: true,
                });
                return;
            }
            await delAll(this.selectIds);
            await this.search(true);
        },
        // 行选择
        rowSelect(selection) {
            this.selectIds = selection.map(p => {
                return { id: p.id };
            });
        },
        /**
         * 开始时间发生变化时触发,设置结束时间不可选择的日期
         * 结束时间应大于等于开始时间,且小于等于当前时间
         * @param {string} startTime 格式化后的日期
         * @param {string} type 当前的日期类型
         */
        onStartTimeChange(startTime, type) {
            this.formItem.createStartTime = startTime;
            this.createEndTimeOption = {
                disabledDate(endTime) {
                    return endTime < new Date(startTime) || endTime > Date.now();
                },
            };
        },
        /**
         * 结束时间发生变化时触发,设置开始时间不可选择的日期
         * 开始时间小于等于结束时间,且小于等于当前时间
         * @param {string} date 格式化后的日期
         * @param {string} type 当前的日期类型
         */
        onEndTimeChange(endTime, type) {
            this.formItem.createEndTime = endTime;
            this.createStartTimeOption = {
                disabledDate(startTime) {
                    return startTime > new Date(endTime) || startTime > Date.now();
                },
            };
        },
    },
    async mounted() {
        await this.search(true);
    },
};
</script>
<style>
</style>
